<div class="site-picker site-combo-v2" [class.disabled]="disabled" #sitePickerRoot>
  <div class="site-picker-control">
    <button
      #sitePickerFieldButton
      type="button"
      class="site-picker-field"
      [disabled]="disabled"
      [attr.data-has-value]="selectedSites.length > 0"
      [attr.aria-expanded]="sitePickerOpen"
      (click)="toggleSitePicker($event)"
    >
      <span class="site-picker-field-text">{{ sitePickerFieldText }}</span>
      <span class="site-picker-caret" aria-hidden="true">▾</span>
    </button>

    <div
      *ngIf="sitePickerOpen"
      class="site-picker-panel floating"
      [class.two-columns]="sitePickerTwoColumns"
      [ngStyle]="sitePickerPanelStyle"
      (click)="$event.stopPropagation()"
    >
      <div class="site-picker-top">
        <input
          #sitePickerSearchInput
          class="site-picker-search"
          type="text"
          [placeholder]="'search' | translate"
          [value]="sitePickerSearch"
          (input)="onSitePickerSearch($event)"
        />
        <div class="site-picker-actions">
          <button type="button" class="site-picker-action primary" (click)="selectAllSites()">{{ 'all' | translate }}</button>
          <button type="button" class="site-picker-action" (click)="clearAllSites()">{{ 'clear_all' | translate }}</button>
          <button type="button" class="site-picker-action end" (click)="collapseSiteGroups()">Collapse</button>
        </div>
      </div>

      <div class="site-picker-list" role="listbox" aria-multiselectable="true">
        <div *ngFor="let group of sitePickerGroups; trackBy: trackBySiteGroupId" class="site-picker-group">
          <div
            class="site-picker-group-header"
            role="button"
            tabindex="0"
            [class.expanded]="!isGroupCollapsed(group.id)"
            (mousedown)="$event.preventDefault(); toggleSiteGroupCollapsed(group.id, $event)"
            (keydown.enter)="toggleSiteGroupCollapsed(group.id, $event)"
            (keydown.space)="$event.preventDefault(); toggleSiteGroupCollapsed(group.id, $event)"
          >
            <i
              class="fa site-picker-arrow"
              [ngClass]="isGroupCollapsed(group.id) ? 'fa-caret-right' : 'fa-caret-down'"
              aria-hidden="true"
            ></i>

            <button
              type="button"
              class="site-picker-box site-picker-group-box"
              [attr.data-state]="getSiteGroupState(group.items)"
              (mousedown)="$event.preventDefault(); toggleSiteGroup(group.items, $event)"
              (keydown.enter)="toggleSiteGroup(group.items, $event)"
              (keydown.space)="$event.preventDefault(); toggleSiteGroup(group.items, $event)"
            >
              <i class="fa fa-check"></i>
            </button>

            <span class="site-picker-group-name">{{ group.label }}</span>
            <i class="fa fa-star site-picker-flags" *ngIf="group.icon === 'star'" aria-hidden="true"></i>
            <i class="fa fa-globe site-picker-flags" *ngIf="group.icon === 'globe'" aria-hidden="true"></i>
            <span class="site-picker-group-flags" *ngIf="group.flagCodes?.length">
              <span
                *ngFor="let code of group.flagCodes"
                class="flag-icon flag-icon-{{ code.toLowerCase() }} site-picker-flag-icon"
              ></span>
            </span>
            <span class="site-picker-count">{{ getSiteGroupSelectedCount(group.items) }}/{{ group.items.length }}</span>
          </div>

          <div *ngIf="!isGroupCollapsed(group.id)" class="site-picker-group-items">
            <div
              *ngFor="let site of group.items; trackBy: trackBySiteId"
              class="site-picker-item"
              role="option"
              tabindex="0"
              [attr.aria-checked]="isSiteSelected(site)"
              [class.selected]="isSiteSelected(site)"
              (mousedown)="$event.preventDefault(); toggleSiteSelection(site, $event)"
              (keydown.enter)="toggleSiteSelection(site, $event)"
              (keydown.space)="$event.preventDefault(); toggleSiteSelection(site, $event)"
            >
              <span class="site-picker-box" [attr.data-state]="isSiteSelected(site) ? 'on' : 'off'">
                <i class="fa fa-check"></i>
              </span>
              <span class="site-picker-item-label">{{ site.item_text }}</span>
              <button
                *ngIf="showFavorites"
                type="button"
                class="site-picker-favorite"
                [class.active]="isSiteFavorite(site)"
                [title]="'favorites' | translate"
                (mousedown)="$event.preventDefault(); toggleSiteFavorite(site, $event)"
                (keydown.enter)="toggleSiteFavorite(site, $event)"
                (keydown.space)="$event.preventDefault(); toggleSiteFavorite(site, $event)"
              >
                <i class="fa" [ngClass]="isSiteFavorite(site) ? 'fa-star' : 'fa-star-o'"></i>
              </button>
            </div>

            <div *ngIf="group.items.length === 0" class="site-picker-empty">{{ group.emptyMessage }}</div>
          </div>
        </div>
      </div>

      <div class="site-picker-footer">
        <span>{{ sitePickerSummaryText }}</span>
        <button type="button" class="site-picker-apply" (click)="applySitePicker()">{{ 'apply_filter' | translate }}</button>
      </div>
    </div>
  </div>
</div>
